import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SpinLoader from '../../../shared/SpinLoader/spin.loader.vue';
// @ts-ignore
import pdf from 'vue-pdf';
@Component({
    components: {
        pdf,
        SpinLoader
    }
})
export default class VuePdfDemo extends Vue {
    public url: string =
        `http://onepiece-test-oss.oss-us-west-1.aliyuncs.com/CmaPdf/20190903025053127.pdf`;
    public src = pdf.createLoadingTask(this.url);
    public numPages: any[] = [];
    public isLoading = true;
    public created() {
        const self = this;
        this.src.then((pdfIns: any) => {
            this.isLoading = false;
            self.numPages = pdfIns.numPages;
        });
    }
    public mounted() {
    }
}
